//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/mesh/swarm.proto.
 */
export const file_dxos_mesh_swarm = /*@__PURE__*/ fileDesc("ChVkeG9zL21lc2gvc3dhcm0ucHJvdG8SD2R4b3MubWVzaC5zd2FybSKzAQoMU3dhcm1NZXNzYWdlEiMKBXRvcGljGAMgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRIoCgpzZXNzaW9uX2lkGAQgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRIqCgRkYXRhGAUgASgLMhwuZHhvcy5tZXNoLnN3YXJtLk1lc3NhZ2VEYXRhEigKCm1lc3NhZ2VfaWQYBiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5IvYBCgtNZXNzYWdlRGF0YRInCgVvZmZlchgBIAEoCzIWLmR4b3MubWVzaC5zd2FybS5PZmZlckgAEikKBmFuc3dlchgCIAEoCzIXLmR4b3MubWVzaC5zd2FybS5BbnN3ZXJIABIpCgZzaWduYWwYAyABKAsyFy5keG9zLm1lc2guc3dhcm0uU2lnbmFsSAASNAoMc2lnbmFsX2JhdGNoGAQgASgLMhwuZHhvcy5tZXNoLnN3YXJtLlNpZ25hbEJhdGNoSAASJwoFY2xvc2UYBSABKAsyFi5keG9zLm1lc2guc3dhcm0uQ2xvc2VIAEIJCgdwYXlsb2FkIgcKBU9mZmVyIhcKBUNsb3NlEg4KBnJlYXNvbhgBIAEoCSJiCgZBbnN3ZXISDgoGYWNjZXB0GAEgASgIEjMKEG9mZmVyX21lc3NhZ2VfaWQYAiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SACIAQFCEwoRX29mZmVyX21lc3NhZ2VfaWQiMgoGU2lnbmFsEigKB3BheWxvYWQYASABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0IjcKC1NpZ25hbEJhdGNoEigKB3NpZ25hbHMYASADKAsyFy5keG9zLm1lc2guc3dhcm0uU2lnbmFsYgZwcm90bzM", [file_google_protobuf_struct, file_dxos_keys]);
/**
 * Describes the message dxos.mesh.swarm.SwarmMessage.
 * Use `create(SwarmMessageSchema)` to create a new message.
 */
export const SwarmMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_swarm, 0);
/**
 * Describes the message dxos.mesh.swarm.MessageData.
 * Use `create(MessageDataSchema)` to create a new message.
 */
export const MessageDataSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_swarm, 1);
/**
 * Describes the message dxos.mesh.swarm.Offer.
 * Use `create(OfferSchema)` to create a new message.
 */
export const OfferSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_swarm, 2);
/**
 * Describes the message dxos.mesh.swarm.Close.
 * Use `create(CloseSchema)` to create a new message.
 */
export const CloseSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_swarm, 3);
/**
 * Describes the message dxos.mesh.swarm.Answer.
 * Use `create(AnswerSchema)` to create a new message.
 */
export const AnswerSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_swarm, 4);
/**
 * Describes the message dxos.mesh.swarm.Signal.
 * Use `create(SignalSchema)` to create a new message.
 */
export const SignalSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_swarm, 5);
/**
 * Describes the message dxos.mesh.swarm.SignalBatch.
 * Use `create(SignalBatchSchema)` to create a new message.
 */
export const SignalBatchSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_swarm, 6);
//# sourceMappingURL=swarm_pb.js.map